import { useState, useEffect } from 'react';
import { 
  getTranslatedSystemValue, 
  getSystemKeyFromValue,
  venueSystems, 
  getTranslatedSystems 
} from '../data/venueSystems';
import { useTranslationReload } from './useTranslationReload';

/**
 * Hook personalizzato per gestire le traduzioni dei sistemi dei locali
 * Forza il re-rendering quando cambia la lingua
 */
export const useSystemTranslation = () => {
  const { t, i18n } = useTranslationReload();
  const [localSystems, setLocalSystems] = useState(venueSystems);

  useEffect(() => {
    setLocalSystems(getTranslatedSystems());
  }, [t]);

  // Traduce un valore di sistema
  const translateSystem = (value: string): string => {
    if (!value) return '';
    
    // Se è una chiave di traduzione (inizia con "systems.")
    if (value.startsWith('systems.')) {
      return getTranslatedSystemValue(value);
    }
    
    // Se è un valore diretto che potrebbe avere una chiave
    const keyFromValue = getSystemKeyFromValue(value);
    if (keyFromValue !== value && keyFromValue.startsWith('systems.')) {
      return getTranslatedSystemValue(keyFromValue);
    }
    
    return value;
  };

  // Converte un valore tradotto nella sua chiave di traduzione
  const getSystemKey = (value: string): string => {
    return getSystemKeyFromValue(value);
  };

  return {
    systems: localSystems,
    translateSystem,
    getSystemKey,
    t,
    i18n
  };
};

export default useSystemTranslation; 